import React from "react";
import { useTheme } from "./theme";

export function TextInput({ ...rest }) {
    const { altTextColor, modularScale } = useTheme();
    const fontSize = modularScale(-1);
    return (
        <>
            <input type="text" {...rest} />
            <style jsx>{`
                input {
                    font-size: ${fontSize}em;
                    padding: 1em 1.25em;
                    border-radius: 6em;
                    width: 15em;
                    border: 2px solid #fff;
                    color: ${altTextColor};
                }
                input:focus,
                input:hover {
                    outline: 0;
                    border-color: ${altTextColor};
                }
            `}</style>
        </>
    );
}
